import React, { useState, useEffect, useRef } from "react";
import styled from 'styled-components';
import { Tag, Input } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const Styles = styled.div`
	.site-tag-plus {
    background: #fff;
    border-style: dashed;
  }
`;

export default function TagInput({
  value,
  onChange = () => { },
  newPlaceholder = 'New Tag',
  allowClear = false
}) {
  const input = useRef();
  const [model, setModel] = useState([]);
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');
  useEffect(() => {
    if (value && Array.isArray(value)) {
      setModel(value);
    }
  }, [value]);
  const handleClose = removeTag => {
    const tags = model.filter(tag => tag !== removeTag);
    setModel(tags);
    onChange(tags);
  }
  const showInput = () => {
    setInputVisible(true);
    setTimeout(() => {
      if (input.current) {
        input.current.focus();
      }
    }, 100)

  }
  const handleInputConfirm = () => {
    if (inputValue && model.indexOf(inputValue) === -1) {
      const tags = [...model, inputValue];
      setModel(tags);
      onChange(tags);
    }
    setInputVisible(false);
    setInputValue('');
  };
  const forMap = tag => {
    const tagElem = (
      <Tag
        closable
        onClose={e => {
          e.preventDefault();
          handleClose(tag);
        }}
      >
        {tag}
      </Tag>
    );
    return (
      <span key={tag} style={{ display: 'inline-block' }}>
        {tagElem}
      </span>
    );
  };
  const tagChild = model.map(forMap);

  return <Styles>
    <div style={{ marginBottom: 16 }}>
      {tagChild}
    </div>
    {inputVisible ? (
      <Input
        allowClear={allowClear}
        ref={input}
        placeholder={newPlaceholder}
        type="text"
        size="small"
        value={inputValue}
        onChange={e => setInputValue(e.target.value)}
        onBlur={handleInputConfirm}
        onPressEnter={handleInputConfirm}
      />
    ) : null}
    {!inputVisible ? (
      <Tag hidden={inputVisible} onClick={showInput} className="site-tag-plus">
        <PlusOutlined /> {newPlaceholder}
      </Tag>
    ) : null}

  </Styles>
}